import { INotificationSetting } from '../../../types/notifications';
import { DELIVERY_METHOD } from 'src/constants/deliveryTypes';
import { defaultTTranslate, ShortCode } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';

enum WalletNotificationEvents {
  DEPOSIT = 'd',
}

export const defaultWalletNotificationSetting: INotificationSetting = {
  id: 0,
  subject: defaultTTranslate,
  message: defaultTTranslate,
  deliveryMethod: DELIVERY_METHOD.APP_NOTIFICATION,
  event: WalletNotificationEvents.DEPOSIT,
  status: 0,
};

export const walletNotificationSettingEventPickerOptions = (): IPickerOption[] => {
  return [{ value: WalletNotificationEvents.DEPOSIT, label: localeStore.t(WalletNotificationEvents.DEPOSIT + '_event') }];
};

export const walletNotificationSettingShortCodePickerOptions = (): IPickerOption[] => {
  return [
    { value: ShortCode.ORDER_NUMBER, label: localeStore.t('order_number_1') },
    { value: ShortCode.BALANCE_TYPE, label: localeStore.t('balance_type') },
    { value: ShortCode.BALANCE_AMOUNT, label: localeStore.t('balance_amount') },
    { value: ShortCode.VALIDITY, label: localeStore.t('validity') },
  ];
};
